//Creates new CuvetteSeal and assigns ID and type
export const createCuvetteSeal = (data) => {
    //data = {id, type}
    return { type: "CREATE_CUVETTE_SEAL", payload: data}
}

export const setCuvetteSealHeld = (data) => {
    //data = {id, inScene}
    return { type: "SET_CUVETTE_SEAL_HELD", payload: data}
}

//Set whether the pipette controls are displayed or not
export const setCuvetteSealControlVisibility = (data) => {
    //data = {id, animatingOut}
    return { type: "SET_CUVETTE_SEAL_CONTROLS_VISIBLE", payload: data}
  }

  export const setCuvetteSealsInScene = data => {
    //data = {type, inScene}
    return { type: "SET_CUVETTE_SEALS_IN_SCENE", payload: data };
  };